// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2baa94a0","49":"9ef3c55b","124":"5d0e6a31","157":"c081a832","204":"f10f9d2f","472":"0d0f3708","521":"ba82a1a5","615":"e06940d4","704":"e34ca25b","710":"acc5cce5","756":"d980b4db"}[chunkId] + ".chunk.js";
};